<template>
    <div>
        <apexchart type="line" :options="chartOptions" :series="chartSeries"></apexchart>
    </div>
</template>

<script>
    import Vue from 'vue';
    import VueApexCharts from 'vue-apexcharts';
    Vue.component('Apexchart', VueApexCharts);

    export default {
        name: "AffiliateChart",
        props: [
          "selected_option",
          "wallet", //wallet address
        ],
        watch: {
            selected_option(newOption, oldOption) {
                if (newOption === "all") {
                    this.displayAllTime();
                }
                else if (newOption === "week") {
                    this.displayPastWeek();
                }
                else if (newOption === "month") {
                    this.displayPastMonth();
                }
            }
        },
        mounted() {
            this.querySubGraph(this.wallet) //use wallet "0x8AcB2d4aFCCA1540C69a32224Ba5f2D7795E1e6A" for testing
                .then(() => {this.displayAllTime()}); //default to past week
        },
        methods: {
            filterData(affiliateBlocks, zoomEarnedBlocks, bottomDate) { //returns array of formatted xy pairs with blockTimestamp >= bottomDate
                bottomDate = new Date(bottomDate); //convert to Date object if not already

                let affiliateCount = 0;
                let zoomEarnedCount = 0;

                //discard blocks that are older than bottomDate
                const filteredAffiliateBlocks = affiliateBlocks.filter((block) => {
                    if (new Date(block.blockTimestamp).getTime() >= bottomDate.getTime()) {
                        return true;
                    }
                    else {
                        affiliateCount++; //count affiliates from discarded blocks
                        return false;
                    }
                });
                const filteredZoomEarnedBlocks = zoomEarnedBlocks.filter((block) => {
                    if (new Date(block.blockTimestamp).getTime() >= bottomDate.getTime()) {
                        return true;
                    }
                    else {
                        zoomEarnedCount += parseInt(block.zoomReward); //count zoom earned from discarded blocks
                        return false;
                    }
                });
                
                const affiliateData = [];
                const zoomEarnedData = [];

                //add an xy pair for the bottom date
                if (bottomDate.getTime() !== new Date(0).getTime()) { //not displaying "all time"
                    affiliateData.push({x: bottomDate, y: affiliateCount});
                    zoomEarnedData.push({x: bottomDate, y: zoomEarnedCount});
                }
                else if (bottomDate.getTime() === new Date(0).getTime() && affiliateBlocks.length === 0 && zoomEarnedBlocks.length === 0) { //stretch out the graph if data is limited and displaying "all time"
                    let weekPrior = new Date(); //for displaying "all time" with limited data
                    weekPrior.setDate(weekPrior.getDate() - 7);
                    affiliateData.push({x: weekPrior, y: affiliateCount});
                    zoomEarnedData.push({x: weekPrior, y: zoomEarnedCount});
                }
                else if (bottomDate.getTime() === new Date(0).getTime() && affiliateBlocks.length === 0) { //stretch out the graph if data is limited and displaying "all time"
                    affiliateData.push({x: new Date(filteredZoomEarnedBlocks[0].blockTimestamp), y: affiliateCount});
                }
                else if (bottomDate.getTime() === new Date(0).getTime() && zoomEarnedBlocks.length === 0) { //stretch out the graph if data is limited and displaying "all time"
                    zoomEarnedData.push({x: new Date(filteredAffiliateBlocks[0].blockTimestamp), y: zoomEarnedCount});
                }

                //format data into xy pairs
                filteredAffiliateBlocks.map((block) => {
                    affiliateCount++;
                    affiliateData.push({x: new Date(block.blockTimestamp), y: affiliateCount});
                });
                filteredZoomEarnedBlocks.map((block) => {
                    zoomEarnedCount += parseInt(block.zoomReward);
                    console.log(new Date(block.blockTimestamp))
                    zoomEarnedData.push({x: new Date(block.blockTimestamp), y: zoomEarnedCount});
                });

                //add an xy pair for the current date
                affiliateData.push({x: new Date(), y: affiliateCount});
                zoomEarnedData.push({x: new Date(), y: zoomEarnedCount});

                return [affiliateData, zoomEarnedData];
            },
            displayAllTime() {

                const epoch = new Date(0);
                const dataArray = this.filterData(this.affiliateBlocks, this.zoomEarnedBlocks, epoch);

                this.chartSeries = [
                    {
                        //# affiliates
                        data: dataArray[0],
                    },
                    {
                        //total zoom earned
                        data: dataArray[1],
                    }
                ];
            },
            displayPastWeek() {

                const weekBeforeToday = new Date();
                weekBeforeToday.setDate(weekBeforeToday.getDate() - 7);
                weekBeforeToday.setHours(0, 0, 0, 0); //set to midnight
                const dataArray = this.filterData(this.affiliateBlocks, this.zoomEarnedBlocks, weekBeforeToday);

                this.chartSeries = [
                    {
                        //# affiliates
                        data: dataArray[0],
                    },
                    {
                        //total zoom earned
                        data: dataArray[1],
                    }
                ];
            },
            displayPastMonth() {

                const monthBeforeToday = new Date();
                monthBeforeToday.setMonth(monthBeforeToday.getMonth() - 1);
                monthBeforeToday.setHours(0, 0, 0, 0); //set to midnight
                const dataArray = this.filterData(this.affiliateBlocks, this.zoomEarnedBlocks, monthBeforeToday);

                this.chartSeries = [
                    {
                        //# affiliates
                        data: dataArray[0],
                    },
                    {
                        //total zoom earned
                        data: dataArray[1],
                    }
                ];
            },
            querySubGraph: async function (walletAddress) {
                const query = `query {
                    logSponsorLinkeds(
                        filter: {
                        sponsor: {
                            equalTo: "${walletAddress}"
                        }
                        }, orderBy: BLOCK_NUMBER_ASC
                    ) {
                        nodes {
                            blockTimestamp
                            sponsor
                            affiliate
                        }
                    }
                    logSponsorRewards(
                        filter: {
                        sponsor: {
                            equalTo: "${walletAddress}"
                        }
                        }, orderBy: BLOCK_NUMBER_ASC
                    ) {
                        nodes {
                            blockTimestamp
                            sponsor
                            zoomReward
                        }
                    }
                }`;

                const graphEndPoint = "https://cryptoz.cards:3000"

                try {

                    const result = await fetch(
                        graphEndPoint,
                        {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            Accept: "application/json",
                        },
                        body:JSON.stringify({
                            query
                            }),
                        }
                    );
                    const res = await result.json();

                    const affiliateBlocks = res.data.logSponsorLinkeds.nodes;
                    let totalAffiliates = 0;
                    affiliateBlocks.map((node) => {
                        totalAffiliates += 1;
                    });
                    this.totalAffiliates = totalAffiliates;
                    this.affiliateBlocks = affiliateBlocks;

                    const zoomEarnedBlocks = res.data.logSponsorRewards.nodes;
                    let totalZoomEarned = 0;
                    zoomEarnedBlocks.map((node)=>{
                        totalZoomEarned += parseInt(node.zoomReward);
                    });
                    this.totalZoomEarned = totalZoomEarned;
                    this.zoomEarnedBlocks = zoomEarnedBlocks;

                } catch (err){
                    console.log(err);
                }
            },
        },
        data() {
            return {

                chartSeries: [
                    {
                        name: "# Affiliates",
                        data: [],
                    },
                    {
                        name: "Total Zoom Earned",
                        data: [],
                    }
                ],
                totalAffiliates: 0,
                affiliateBlocks: [],
                totalZoomEarned: 0,
                zoomEarnedBlocks: [],
                
                chartOptions: {
                    chart: {
                        height: 350,
                        type: "line",
                        stacked: false,
                        zoom: {
                            enabled: false,
                        },
                        toolbar: {
                            show: false,
                        }
                    },
                    tooltip: {
                        followCursor: false,
                        shared: true,
                        inverseOrder: false,
                        custom: undefined,
                        fillSeriesColor: true,
                        x: {
                            show: true,
                        },
                        style: {
                            fontFamily: "Truculenta, sans-serif",
                            fontSize: "18px",
                        },
                    },
                    dataLabels: {
                        enabled: false
                    },
                    stroke: {
                        curve: "stepline",
                        width: [4, 4],
                    },
                    markers: {
                        size: 3,
                    },
                    colors: ["#FF19B1", "#00D1FF"],
                    xaxis: {
                        //categories are defined in chartSeries
                        type: "datetime",
                        labels: {
                            style: {
                                colors: "#FFFFFF",
                            }
                        }
                    },
                    yaxis: [
                        {
                        axisTicks: {
                            show: true,
                        },
                        axisBorder: {
                            show: true,
                            color: "#FF19B1",
                        },
                        labels: {
                            style: {
                            colors: "#FF19B1",
                            },
                        },
                        title: {
                            text: "# Affiliates",
                            style: {
                            color: "#FF19B1",
                            },
                        },
                        },
                        {
                        seriesName: "Zoom Rewarded",
                        opposite: true,
                        axisTicks: {
                            show: true,
                        },
                        axisBorder: {
                            show: true,
                            color: "#00D1FF",
                        },
                        labels: {
                            style: {
                            colors: "#00D1FF",
                            },
                        },
                        title: {
                            text: "Zoom Rewarded",
                            style: {
                            color: "#00D1FF",
                            },
                        },
                        },
                    ],
                    legend: {
                        labels: {
                        colors: "#FFFFFF",
                        },
                    },
                },

            }
        }
    }
</script>

<style lang="scss">

.apexcharts-tooltip-title {
    background: #00e44c !important;
    font-weight: bold !important;
}

</style>